var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotography(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6666C22.7615 26.6666 25 24.4281 25 21.6666C25 18.9051 22.7615 16.6666 20 16.6666C17.2385 16.6666 15 18.9051 15 21.6666C15 24.4281 17.2385 26.6666 20 26.6666Z",
    stroke: "#7B00FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28V15.3333C5 13.4665 5 12.533 5.36332 11.82C5.68288 11.1928 6.19282 10.6828 6.82003 10.3633C7.53307 9.99996 8.4665 9.99996 10.3333 9.99996H12.0911C12.296 9.99996 12.3984 9.99996 12.4929 9.98913C12.9861 9.93264 13.4284 9.65928 13.6995 9.24344C13.7514 9.16374 13.7973 9.07209 13.8889 8.88884C14.0722 8.52233 14.1638 8.33906 14.2677 8.17966C14.8098 7.34799 15.6945 6.80126 16.6808 6.68828C16.8698 6.66663 17.0747 6.66663 17.4845 6.66663H22.5155C22.9253 6.66663 23.1302 6.66663 23.3192 6.68828C24.3055 6.80126 25.1902 7.34799 25.7323 8.17966C25.8362 8.33904 25.9278 8.52238 26.1112 8.88884C26.2027 9.07211 26.2485 9.16374 26.3005 9.24344C26.5717 9.65928 27.0138 9.93264 27.507 9.98913C27.6017 9.99996 27.704 9.99996 27.909 9.99996H29.6667C31.5335 9.99996 32.467 9.99996 33.18 10.3633C33.8072 10.6828 34.3172 11.1928 34.6367 11.82C35 12.533 35 13.4665 35 15.3333V28C35 29.8668 35 30.8003 34.6367 31.5133C34.3172 32.1405 33.8072 32.6505 33.18 32.97C32.467 33.3333 31.5335 33.3333 29.6667 33.3333H10.3333C8.4665 33.3333 7.53307 33.3333 6.82003 32.97C6.19282 32.6505 5.68288 32.1405 5.36332 31.5133C5 30.8003 5 29.8668 5 28Z",
    stroke: "#7B00FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/photography.422ffb8c3004ca08660fee34497a1b5a.svg";
export { ForwardRef as ReactComponent };